export function filterLibrary() {
  const filters = document.querySelectorAll('.library-filter');
  if(filters.length){
    filters.forEach((filter) => {
      const trigger = filter.querySelector('dt');
      if(trigger){
        trigger.addEventListener('click', () => {
          const active = document.querySelector('.library-filter.is-active');
          if(active) active.classList.remove('is-active');
          filter.classList.add('is-active');
          document.body.classList.add('is-library-filter-active');
        })
      }
    });
  }
  const close = document.querySelector('.library-filter-close');
  if(close) {
    close.addEventListener('click', (e) => {
      e.preventDefault();
      if(filters.length){
        filters.forEach((filter) => {
          filter.classList.remove('is-active');
        })
        document.body.classList.remove('is-library-filter-active');
      }
    })
  }
}